export interface VoiceOption {
  id: string;
  name: string;
  gender: 'female' | 'male';
  label: string;
  desc: string;
}

export const VOICE_OPTIONS: VoiceOption[] = [
  { id: 'Kore', name: 'Kore', gender: 'female', label: 'Feminino (Padrão)', desc: 'Tom neutro e didático.' },
  { id: 'Aoede', name: 'Aoede', gender: 'female', label: 'Feminino (Expressivo)', desc: 'Tom alegre e didático.' },
  { id: 'Charon', name: 'Charon', gender: 'female', label: 'Feminino (Claro)', desc: 'Tom formal e claro.' },
  { id: 'Zephyr', name: 'Zephyr', gender: 'female', label: 'Feminino (Brilhante)', desc: 'Tom jovem e enérgico.' },
  { id: 'Leda', name: 'Leda', gender: 'female', label: 'Feminino (Acolhedor)', desc: 'Tom calmo e suave.' },
  { id: 'Puck', name: 'Puck', gender: 'male', label: 'Masculino (Amigável)', desc: 'Tom amigável e caloroso.' },
  { id: 'Fenrir', name: 'Fenrir', gender: 'male', label: 'Masculino (Calmo)', desc: 'Tom pausado e moderado.' },
  { id: 'Orus', name: 'Orus', gender: 'male', label: 'Masculino (Firme)', desc: 'Tom assertivo e maduro.' }
];
